import { Params, PRIMARY_OUTLET, Router } from '@angular/router';

const SYSTEM_SEGMENT = 'system';

export const extractSystemBkFromCurrentNavigation = (router: Router): string | null => {
  const segments = router.getCurrentNavigation()?.extractedUrl.root.children[PRIMARY_OUTLET]?.segments ?? [];
  const systemSegmentIndex = segments.findIndex(({ path }) => path === SYSTEM_SEGMENT);

  return systemSegmentIndex === -1 ? null : segments[systemSegmentIndex + 1]?.path ?? null;
};

// allows you to access all params from the Angular router outside of a routing context (e.g. <router-outlet>)
// typically to be used when wanting to access route parameters from within a service
export const extractAllParamsFromRouter = (router: Router): Params => {
  let params = {};
  let route = router.routerState.snapshot.root;
  do {
    params = { ...params, ...route.params };
    route = route.firstChild;
  } while (route);

  return params;
};
